import { useTranslation } from "react-i18next";
import { CustomIcon } from "components/icon/customIcon.component";
import { ColorV2 } from "config/colors";
import type { WorkerDocument } from "model/WorkerDocument";
import { formatBytes } from "utils/utils";
import {
  WorkerDocumentDownload,
  WorkerDocumentDownloadWrapper,
  WorkerDocumentFileSize,
  WorkerDocumentList,
  WorkerDocumentListItem,
  WorkerDocumentListItemTitle,
  WorkerDocumentListTitle,
  WorkerDocumentNoFiles,
} from "./workerDocument.styled";

interface WorkerDocumentsProps {
  readonly documents: readonly WorkerDocument[];
}

export const WorkerDocuments = (props: WorkerDocumentsProps): JSX.Element => {
  const { documents } = props;
  const { t } = useTranslation();

  return (
    <>
      <WorkerDocumentListTitle>
        {t("General.Documents")}
      </WorkerDocumentListTitle>
      <WorkerDocumentList>
        {documents.length > 0 &&
          documents.map((workerDocument) => (
            <WorkerDocumentListItem
              key={`${workerDocument.fileName}-${workerDocument.downloadUrl}`}
            >
              <WorkerDocumentListItemTitle>
                <span>{workerDocument.fileName}</span>
              </WorkerDocumentListItemTitle>
              <WorkerDocumentDownloadWrapper>
                <WorkerDocumentDownload
                  href={workerDocument.downloadUrl}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <span>{t("General.Download")}</span>
                  <WorkerDocumentFileSize>
                    ({formatBytes(workerDocument.fileSize)})
                  </WorkerDocumentFileSize>
                  <CustomIcon
                    size="14px"
                    color={ColorV2.White}
                    name="v2/download"
                  />
                </WorkerDocumentDownload>
              </WorkerDocumentDownloadWrapper>
            </WorkerDocumentListItem>
          ))}
        {documents.length === 0 && (
          <WorkerDocumentNoFiles>
            {t("General.NoDocumentsUploaded")}
          </WorkerDocumentNoFiles>
        )}
      </WorkerDocumentList>
    </>
  );
};
